/**
 * A helper service for logging Google Analytics
 * @type {Object}
 */
import ReactGA from 'react-ga';
import {
  REACT_APP_GA_ACCOUNT,
  REACT_APP_DEBUG_GA,
} from '../../constants/analytics';

/**
 * Initialist the GA and hot jar tracking
 */
export const initTracking = () => {
  ReactGA.initialize(REACT_APP_GA_ACCOUNT, {
    debug: REACT_APP_DEBUG_GA,
    titleCase: false,
  });
};

const analyticsService = {};
/**
 * Method to log a general event in Google Analytics
 * @param event Object - The event for Google Analytics with category, action and label properties
 */
analyticsService.logEvent = (event) => {
  ReactGA.event(event);
};

export default analyticsService;
